import {
  Box,
  Button,
  Modal as ModalBase,
  Stack,
  TextField,
} from "@mui/material";
import { BaseSyntheticEvent, FC, useEffect, useState } from "react";
import { getModalStyle, StyledText } from "./styles";
import { Close } from "@mui/icons-material";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  onComplete: (text: string) => void;
  title: string;
  defaultValue?: string;
  size?: "small" | "medium" | "large";
};

export const ModalWithTextArea: FC<ModalProps> = ({
  title,
  open,
  defaultValue,
  onClose,
  onComplete,
  size = "small",
}) => {
  const style = getModalStyle(size);
  const [textarea, setTextarea] = useState<string>("");
  useEffect(() => {
    if (defaultValue) {
      setTextarea(defaultValue);
    }
  }, [defaultValue]);
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              border: "none",
              background: "none",
              cursor: "pointer",
            }}
          >
            <Close />
          </button>
        </Box>
        <StyledText id="modal-modal-title">{title}</StyledText>
        <Box id="modal-modal-description">
          <form
            onSubmit={(event: BaseSyntheticEvent) => {
              event.preventDefault();
              event.stopPropagation();
              onComplete(textarea);
            }}
          >
            <TextField
              fullWidth
              multiline
              rows={4}
              value={textarea}
              onChange={(e) => setTextarea(e.target.value)}
            />
            <Stack spacing={2} mt={2} direction="row" justifyContent="flex-end">
              <Box mr={2}>
                <Button variant="outlined" color="primary" onClick={onClose}>
                  Cancel
                </Button>
              </Box>
              <Box>
                <Button variant="contained" color="primary" type="submit">
                  Save
                </Button>
              </Box>
            </Stack>
          </form>
        </Box>
      </Box>
    </ModalBase>
  );
};
